// src/api/updatePreferences.ts
import { getAuth } from "firebase/auth";
import { apiBase } from "../../firebaseConfig";

export interface NotificationPrefs {
  emailEnabled: boolean;
  pushEnabled: boolean;
  smsEnabled: boolean;
}

export async function updatePreferences(
  storeID: string,
  cardDocId: string,
  prefs: NotificationPrefs
): Promise<void> {
  const idToken = await getAuth().currentUser?.getIdToken(true);

  const res = await fetch(`${apiBase()}/updatePreferences`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ storeID, cardDocId, prefs }),
  });

  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
